export const MAANDEN = [
  "januari", "februari", "maart", "april", "mei", "juni",
  "juli", "augustus", "september", "oktober", "november", "december",
];

export const DAGKORT = ["ma", "di", "wo", "do", "vr", "za", "zo"];

export function groupMonths(days) {
  const map = new Map();
  for (const d of days) {
    const key = d.date.slice(0, 7);
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(d);
  }
  return [...map.entries()];
}

export function monthLabel(key) {
  const [y, m] = key.split("-").map(Number);
  return `${MAANDEN[m - 1]} ${y}`;
}

export function firstDow(key) {
  return (new Date(`${key}-01T12:00:00`).getDay() + 6) % 7;
}

export function formatNL(iso) {
  return new Date(`${iso}T12:00:00`).toLocaleDateString("nl-NL", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
}
